import type { FC } from "react";
import { IoArrowBack } from "react-icons/io5";

export interface SimpleTitleProps {
  title: string;
  onReturn?: () => void;
}

export const SimpleTitle: FC<SimpleTitleProps> = ({ title, onReturn }) => {
  return (
    <div className="text-2xl font-medium text-start flex gap-2 items-center">
      {onReturn && (
        <button type="button" onClick={onReturn}>
          {}
          <IoArrowBack />
        </button>
      )}
      {title}
    </div>
  );
};
